import React, { useState, useEffect } from "react";
import axios from "axios";
import Dummylayout from "../pages/Dummylayout";
import BasicCard from "../pages/BasicCard";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../config";

const ProfileDetails = () => {
  const [employee, setEmployee] = useState([]);
  const [grade, setGrade] = useState([]);
  const [profileimage, setProfileImage] = useState(null);
  const [idImage, setIdImage] = useState(null);
  const [file, setFile] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const id = localStorage.getItem("userid");
        const response = await axios.get(
          `${baseURL}/getemployeedetails?uid=` + id
        );
        const data = response.data;
        let arrEmployee = data.employee;
        setEmployee(arrEmployee[0]);
        let gradeid = arrEmployee[0].gradeid;
        setProfileImage(arrEmployee[0].photo);
        setGrade(gradeid);
        // fetchAppraisalTemplate(gradeid);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchEmployeeData();
  }, []);

  const handleProfileImageChange = async (e) => {
    const updatedFormData = new FormData();
    let fileobj = e.target.files[0];
    if (fileobj) {
      setFile(fileobj);
      setProfileImage(fileobj);
      updatedFormData.append("profilepicture", fileobj);
    }

    // Send the formData with the file to the server
    if (fileobj) {
      const id = localStorage.getItem("employeeid");
      try {
        const response = await fetch(`${baseURL}/updateprofilepic?eid=` + id, {
          method: "POST",
          body: updatedFormData,
        });
        if (response.status === 200) {
          alert("Your profile picture updated");
          window.location.href = "/profile";
        } else {
          const errorData = await response.json();
          alert("Error: " + errorData.message);
        }
      } catch (error) {
        alert("Error: " + error.message);
      }
    }
  };

  const updateUserPassowrd = async (json) => {
    const id = localStorage.getItem("userid");
    try {
      const response = await fetch(
        `${baseURL}/updateuserpassword?id=` + id,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Set the Content-Type header
          },
          body: json, // Set the request body to the JSON string
        }
      );
      if (response.status === 200) {
        setShowToast(true);

        setTimeout(() => {
          setShowToast(false);
          navigate("/profile");
        }, 3000);
      } else {
        const errorData = await response.json();
        alert("Error: " + errorData.message);
      }
    } catch (error) {
      alert("Error: " + error.message);
    }
  };
  return (
    <>
      <Dummylayout />

      <BasicCard>
        <div className="col-lg-12">
          <div className="row ">
            <h5>MY PROFILE</h5>
            <br />
            <br />
            <div className="col-lg-4 ">
              <img
                className="float-start mx-5 pb-3"
                width="110"
                alt=""
                src={
                  profileimage
                    ? `${baseURL}/getcertifcate?filename=` +
                      profileimage
                    : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADlAAAA5QGP5Zs8AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAelQTFRF////JG2SQICAJ05iM1VVNXWAM3CFKUtRM3GCJkdRNHCBJkNNJ0BIMnCAM3GAMnCAJDtBNHKAM3GAIzU5IzY7M3GAM3GAKk1WIi8yM3GAISwwM3GAM3GAICgrHyYoHiIjIiUoFBQUFRUUFhUVFhYWFxYWGRkYHBoYHR0eHR4fHh4fHiEiHiEjHx8gIi8zIjE1IjI2Ix4bIyMlIzU6JCAdJCIgJDY8JyIfJ0VNKEZNKSksKSktKTg5LCciLSsnLychL2JvL2VyMGNvMGVzMGZzMGl2MWp4MWt5MWx6Mm17Mm99MyojMzM5M2BpM3B/M3GANXKAN3KAOGx4OjUvO3SAPXSAPjw2Pj45PmVqPz9HP2ZsQF9iQ0VMQ0VNRUVNRUVORkQ9RkZPR1BMSEhRSUlTSkpUU0EzVldfV1dfWU1AXEc3XE9CXn+AXoCAX2l1YGl2Y4KBZk48a1I/b4J+co2iepOVe3uBe5OVgI+Xh46BjGlPjrDHkm5SmXJVnr/Tn7/TocDUo73Npr/PqcPUqq61r4JgsINhsbK1tMjVxZ98xaOCyKF+0aaB1NbY1qmC2ZRk2qB126J23KJ24KyC4qN55Kh65Onu5Oru5qZ75rWV6qh37Kx+7eLc7qx8769/8bGB8vn+87KB9LOCwa3cagAAACF0Uk5TAAcIDQ8YGSwtL0lQfISXmL/ByNXV2uPu7/Lz8/X5/P7+cDzfRAAAAfxJREFUGBllwYk/FFEcAPDfDrsYZtYsu6wZx+t8uSrddEh3aX8Ula5NTCelSESlKBKr0uEs3l/azHvP7O7H9wtJPjVohE0zbARVH2wW0KPoieoBSKdoFqaxNAVS+EMonb+AUsgPnuwIclfuHSJbjl27jFwkGyR/BLkb+wm3/SZyET9wSgiFq0Q6cAa5kAIuDYVbRNh5iRxFQQNHwELhPnGdePNrlGy7iJwVAAAdpeuEbH3w6R9jnwk5iYIO4IuidJy8/MZcf/fuQCnqAxWltsdPmPTiaRtKKgRR6vs6yqS3X/pQCoKBUm/iO5N+JHpRMiCMUmuCeRKtKIXBxA0980ya78ENJpjoGWZsfXV1nbFh9JgQRk/LNFuam1ti0y3oCYOBSe0zzDHTjkkGBDFF/8Ly8kI/pgiCiile/3S8whQq+KIoxZqG1lYWF1fWhppiKEV9ADq6Th3eXV1jT/weG/szYddU7zlyGl06AAQsxLP7qCveNfvh42xXnDp2HTyHaAXAoWGslnId9uTU1KTdQbnaGGrgUkKNVKjvHBwfH+ysp0JjSAHOX0SFuu6H794/6q6jQpEfpNwyKjTbIyN2MxXKcsGTVUK5yrsDA/FKypVkQYrM/Crqanj2vIG6qvIzIV1OQTl13L5DHeUFObBZRl5hcWlFRWlxYV4GeP4Dm5L5s3KTpvYAAAAASUVORK5CYII="
                }
              />
              <br></br>
              <input
                type="FILE"
                onChange={(e) => {
                  handleProfileImageChange(e);
                }}
              />
            </div>
            <div className="col-4 ">
              <span className="vfont fs-">Name</span>
              <p className="bfont fs-5 fw-bold">
                {employee.FirstName} {employee.LastName}
              </p>
              <span className="vfont fs">Position</span>
              <p className="bfont fs-5 fw-bold">{employee.designation}</p>
            </div>
            <div className="col-4 ">
              <span className="vfont fs">Employee ID</span>
              <p className="bfont fs-5 fw-bold"> {employee.employeeid}</p>
              <span className="vfont fs">Grade</span>
              <p className="bfont fs-5 fw-bold">{employee.gradename}</p>
            </div>
          </div>
        </div>
        <hr></hr>

        <Formik
          initialValues={{ password: "" }}
          validationSchema={Yup.object({
            password: Yup.string()
              .min(8, "Password must be at least 8 characters")
              .required("Password is required"),
          })}
          onSubmit={(values, { setSubmitting }) => {
            // Simulate a form submission
            setTimeout(() => {
              const pwd = values.password;
              let json = JSON.stringify(values, null, 2);
              setSubmitting(false);
              updateUserPassowrd(json);
            }, 400);
          }}
        >
          {({ isSubmitting }) => (
            <Form className="m-2">
              <label className="">Change Password *</label>
              <Field
                type="password"
                name="password"
                className="form-control w-25"
                placeholder="Enter your password"
              />
              <ErrorMessage
                name="password"
                component="div"
                className="text-danger"
              />

              <div className="mt-3">
                <button
                  type="submit"
                  className="btn savebtn btn-primary"
                  disabled={isSubmitting}
                >
                  Save
                </button>
              </div>
            </Form>
          )}
        </Formik>
        <div>
          <ToastContainer position="top-center" className="p-3">
            <Toast
              onClose={() => setShowToast(false)}
              show={showToast}
              delay={3000}
              autohide
              className="bg-success text-white"
            >
              <Toast.Header>
                <span className="me-2">✔️</span> {/* Unicode tick mark */}
                <strong className="me-auto">Notification</strong>
              </Toast.Header>
              <Toast.Body>Success!, data updated successfully!</Toast.Body>
            </Toast>
          </ToastContainer>
        </div>
      </BasicCard>
    </>
  );
};

export default ProfileDetails;
